import { createFileRoute } from "@tanstack/react-router";
import { CaselawOverviewPage } from "@/pages/caselaw-overview/ui/caselaw-overview-page";
import { preloadCaselawOverviewQueries } from "@/pages/caselaw-overview/api/preload-caselaw-overview-queries";
import { searchParams } from "@/pages/caselaw-overview/model/search-params";

export const Route = createFileRoute("/_authed/$companySlug/caselaw/")({
  component: CaselawOverviewPage,
  loader: ({ context }) => {
    // company is guaranteed by $companySlug beforeLoad redirect guard
    if (context.company) {
      void preloadCaselawOverviewQueries(context.company.id);
    }
  },
  validateSearch: searchParams,
});
